import { tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { ViewService } from '../../../services/view.service';
import { RecordService } from '../../../services/record.service';
import { ListingService } from '../../../services/listing.service';
import { JobsComponent } from '../../opportunities/jobs/jobs.component';
import { NotificationService } from '../../../services/notification.service';
import { RecurringJobsService } from '../../../services/recurring-jobs.service';

import { data_get, blank, fallback } from '../../../shared/utils/common';
import { LooseObject } from '../../../objects/loose-object';
import { get } from 'lodash-es';

import { PaginatedData } from '../../acs-support/acs-support';
import { ClientStoreService } from '../../../services/client-store.service';

@Component({
  selector: 'jobs-from-recurring-jobs',
  templateUrl: './jobs-from-recurring-jobs.component.html',
  styleUrls: ['./jobs-from-recurring-jobs.component.scss']
})
export class JobsFromRecurringJobsComponent extends JobsComponent implements OnInit, OnDestroy {

  // For checking current recordId
  strCurrentId: string;

  // Widget Jobs Status Filter Items
  arWidgetJobsStatusFilterItems = [
    {id: 'awaiting_scheduling', name: 'awaiting_scheduling'},
    {id: 'scheduled', name: 'scheduled'},
    {id: 'pending', name: 'pending'},
    {id: 'awaiting_invoicing', name: 'awaiting_invoicing'},
    {id: 'completed', name: 'completed'},
    {id: 'cancelled', name: 'cancelled'}
  ];

  private _arSubscriptions: Subscription[] = [];

  public paginationData: PaginatedData;

  get noJobs(): boolean {
    return blank(this.jobsList);
  }

  get jobsList(): LooseObject[] {
    return fallback(data_get(this.paginationData, 'data'), {
      fallback: () => [],
    });
  }

  constructor(
    listService: ListingService,
    viewService: ViewService,
    dialog: MatDialog,
    notifService: NotificationService,
    recordService: RecordService,
    protected route: ActivatedRoute,
    private readonly _recurringJobsService: RecurringJobsService,
    clientStoreService: ClientStoreService,
  ) {
    super(listService, viewService, dialog, notifService, recordService, clientStoreService);
    this.bContinueFetching = false;
  }

  ngOnInit() {
    this
    .route
    .params
    .pipe(
      tap(({id}) => {
        this.strRecordId = id;
      }),
    )
    .subscribe(() => {
      this.loadJobs();
    });
  }

  ngOnDestroy(): void {
    this._arSubscriptions.forEach(sub => sub.unsubscribe());
  }

  loadJobs(numPage: number = 1): void {
    if (this.bLoading) {
      return;
    }

    this.paginationData = null;
    this.bLoading = true;

    const sub = this._recurringJobsService.combinedListForWidget({
      current_page: numPage,
      recurring_job_id: this.strRecordId,
      job_status: fallback(get(this.strSelectStatus, 'id'), {
        fallback: () => null,
      }),
    }).pipe(
      finalize(() => this.bLoading = false),
    ).subscribe((paginationData: PaginatedData) => {
      this.paginationData = paginationData;
    });

    this._arSubscriptions.push(sub);
  }
}
